import {
	Button,
	Link,
	List,
	ListItem,
	ListItemText,
	TextField,
	Typography,
	useTheme,
} from '@mui/material';
import sizeFontCustom from './fontSize.styles';
import { useTranslation } from '../../hooks/useTranslation';

import { getEntityThemedCtaButtonSx } from '../../utils/ctaContrast.utils';
import { handleOtpPaste } from '../../utils/a11y.utils';

function VerifyOtp({
	phoneNumber,
	setVerifyState,
	verifyState,
	handleVerify,
	accountConfirmLinking,
	linkAccountButtonDisabled,
	customDetails,
}) {
	const { t } = useTranslation();
	const theme = useTheme();
	const isDark = customDetails?.darkTheme === true || theme.palette.mode === 'dark';

	return (
		<List
			disablePadding
			sx={{ width: '100%', px: '1rem', pt: { xs: '0.75rem', md: 0 } }}
		>
			<ListItem disablePadding>
				<ListItemText
					disablePadding
					sx={{
						'& .MuiListItemText-primary': {
							color: theme.palette.info.main,
							fontSize: { xs: '1rem', md: '0.85rem' },
							mt: { xs: '0.5rem', md: '0' },
							fontWeight: 600,
							mb: '0.5rem',
						},
						'& .MuiListItemText-secondary': {
							color: theme.palette.black60,
							...sizeFontCustom.subHeading,
						},
						marginBottom: '0.75rem',
					}}
					primary={t('common.labels.enterOtp')}
					primaryTypographyProps={{ component: 'h2', id: 'otp-section-heading' }}
					secondary={
						<>
							{t('accountDiscovery.messages.accLinking')}
							<strong style={{ color: 'black' }}> {phoneNumber}</strong>
						</>
					}
				/>
			</ListItem>
			<ListItem component={'div'} disablePadding sx={{ width: '100%' }}>
				<TextField
					name="otp"
					label={t('common.labels.otp')}
					size="small"
					fullWidth
					value={verifyState.OTP || ''}
					placeholder={t('common.labels.enterOtp')}
					autoComplete="one-time-code"
					error={Boolean(verifyState.otpError)}
					helperText={verifyState.otpError ? verifyState.otpErrorMessage : ''}
					FormHelperTextProps={{ role: 'alert' }}
					inputProps={{
						style: { fontSize: '0.875rem' },
						autoComplete: 'one-time-code',
						inputMode: 'numeric',
					}}
					variant="outlined"
					onChange={(e) => {
						setVerifyState({
							...verifyState,
							OTP: e.target.value,
							otpError: false,
							otpErrorMessage: '',
						});
					}}
					onPaste={handleOtpPaste((value) => {
						setVerifyState({
							...verifyState,
							OTP: value,
							otpError: false,
							otpErrorMessage: '',
						});
					}, 8)}
					sx={{ my: { xs: '0.75rem', md: '0.725rem' } }}
				/>
			</ListItem>
			<ListItem disablePadding>
				{!verifyState.isResend ? (
					<Typography
						textAlign={'left'}
						sx={{ mb: '1rem', ...sizeFontCustom.subHeading }}
					>
						{t('common.buttons.resendOtpin')}
						<strong
							style={{
								color: theme.palette.error.main,
							}}
						>
							{' ' + verifyState.time} sec
						</strong>
					</Typography>
				) : (
					<Link
						component="button"
						type="button"
						underline="none"
						variant="text"
						onClick={handleVerify}
						disabled={!verifyState.isResend || linkAccountButtonDisabled}
						sx={{
							mb: '1.25rem',
							cursor: 'pointer',
							...sizeFontCustom.subHeading,
							background: 'none',
							border: 'none',
							padding: 0,
							font: 'inherit',
						}}
					>
						{t('common.messages.resend')}
					</Link>
				)}
			</ListItem>
			<ListItem disablePadding>
				<Button
					fullWidth
					variant="contained"
					color="primary"
					onClick={accountConfirmLinking}
					disabled={
						!verifyState.OTP ||
						!(
							verifyState.OTP.length === 4 ||
							verifyState.OTP.length === 6 ||
							verifyState.OTP.length === 8
						)
					}
					sx={{
						textTransform: 'capitalize',
						...sizeFontCustom.subHeading,
						...getEntityThemedCtaButtonSx(customDetails, isDark),
					}}
				>
					{t('common.buttons.submit')}
				</Button>
			</ListItem>
		</List>
	);
}

export default VerifyOtp;
